import { createFileRoute, useNavigate } from "@tanstack/react-router";

import { ScannerPage } from "./-components/scanner.page";

export const Route = createFileRoute("/_auth/ticket/scanner")({
  component: RouteComponent
});

function RouteComponent() {
  const navigate = useNavigate();
  const handleScanSuccess = (decodedText: string) => {
    navigate({ to: "/ticket/$ticketId", params: { ticketId: decodedText } });
  };
  const handleScanError = (error: string) => {
    console.error(error);
  };
  return <ScannerPage onScanSuccess={handleScanSuccess} onScanError={handleScanError} />;
}
